document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-eye-select]');
  if (!button) return;
  const picker = button.closest('variant-picker');
  const input = Array.from(picker?.querySelectorAll('.solea-eye-shades input[type="radio"]') || []).find((radio) => radio.value === button.dataset.eyeSelect);
  if (!input) return;
  input.click();
  picker.querySelector('.solea-eye-guide')?.removeAttribute('open');
  input.focus({ preventScroll: true });
});
